// extracted by mini-css-extract-plugin
export default {"perk":"JobPerk_perk__beD7v","perkTextContent":"JobPerk_perkTextContent__lAmZV","ProfileWrrapper":"JobPerk_ProfileWrrapper__n8PBU"};